import Icon from 'launch/components/Icon';
import Card from 'projects/components/Card';
import * as React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

interface Props {
    heading: string;
    onEditClick?: () => void;
    url: string;
}

class SummaryCard extends React.Component<Props> {
    render() {
        const { heading, onEditClick, children } = this.props;

        return (
            <Card variations={['summary']}>
                <div className="card-header">
                    <div className="card-header__inner">
                        <div className="heading heading--h4 heading--no-margin">{heading}</div>
                        <ReactRouterLink
                            onClick={onEditClick}
                            className={'icon-button icon-button--on-dark'}
                            to={this.props.url}
                        >
                            <Icon size={'large'} icon={'edit-1'} />
                        </ReactRouterLink>
                    </div>
                </div>
                <Card.Block>
                    <div className="card-summary-list">{children}</div>
                </Card.Block>
            </Card>
        );
    }
}

export default SummaryCard;
